import { activationApi } from './index'

export default activationApi.middleware
